import React from "react";
import DashboardLayout from "../../../templates/dashboard-template/index";
import { useTranslation } from 'react-i18next';
import ReturnsTable from '../../../components/Table/Returns/returnsTable'
import ReturnPagination from "../../../components/Table/Returns/Pagination/Pagination";
const Returns = () => {  
  const [t, i18n] = useTranslation('common');
    return (
     <DashboardLayout> 
            <div className="page-header-title">
              <h5 className="mt-3 mb-3">Returns</h5>
            </div>   
            <div className="page-container"> 
               <div className="pagination-block"><ReturnPagination/></div>
              <ReturnsTable /> 
            </div>
          <> 
       </>
     </DashboardLayout> 
    ); 
}
export default Returns;